// extracted by mini-css-extract-plugin
module.exports = {"services":"Services_services__aUhS3","webApp":"Services_webApp__bIvXB"};